import React, { useState } from 'react';
import { StyledH3 } from 'components/header';
import { Form, Button, InputGroup, FormControl } from 'react-bootstrap';
import { Formik } from 'formik';
import FlexRow from 'PageTemplates/FlexRowTemplate';
import styled from 'styled-components';
import * as yup from 'yup';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { firstLetterToUpperCase } from 'services/utils/string';
import Select from 'components/FormInputs/Select';

const Wrapper = styled.div`
  max-width: 500px;
`;
const List = styled.div`
  max-height: 600px;
  width: 300px;
  overflow-y: auto;
`;
const RemoveIcon = styled(FontAwesomeIcon)`
  color: red;
  cursor: ${({ disabled }) => (disabled ? 'normal' : 'pointer')};
  opacity: 0.2;
  &:hover {
    opacity: ${({ disabled }) => (disabled ? 0.2 : 1)};
  }
`;

const MdfProducers = ({ mdfProducers, handleSubmit }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [producer, setProducer] = useState('');

  const removeItem = (producer, arr, arrName, setFieldValue) => {
    const newArr = arr.filter((item) => item !== producer);
    setFieldValue(arrName, newArr);
  };
  const addItem = (arr, arrName, setFieldValue) => {
    const newArr = (arr || []).concat({ name: producer });
    setFieldValue(arrName, newArr);
    setProducer('');
  };
  return (
    <div>
      <Formik
        // ONSUBMIT REQUEST
        onSubmit={async (values) =>
          await handleSubmit(
            { ...values },
            () => setIsEdit(false),
            'Zaktualizowano producentów płyt',
          )
        }
        initialValues={{
          mdfProducers,
        }}
        render={(props) => {
          const { values, handleSubmit, setFieldValue } = props;
          return (
            <Form noValidate onSubmit={handleSubmit}>
              <Wrapper>
                <StyledH3>Producenci płyt</StyledH3>
                {values.mdfProducers && values.mdfProducers.length ? (
                  <>
                    <List>
                      <ul>
                        {values.mdfProducers
                          .sort((a, b) => a.name.localeCompare(b.name))
                          .map((item) => (
                            <li key={item._id || item.name}>
                              <FlexRow justify="space-between">
                                {item.name}{' '}
                                <RemoveIcon
                                  disabled={!isEdit}
                                  title="Usuń"
                                  icon={faMinusCircle}
                                  onClick={
                                    !isEdit
                                      ? null
                                      : () => {
                                          removeItem(
                                            item,
                                            values.mdfProducers,
                                            'mdfProducers',
                                            setFieldValue,
                                          );
                                        }
                                  }
                                />
                              </FlexRow>
                            </li>
                          ))}
                      </ul>
                    </List>
                  </>
                ) : null}{' '}
                {isEdit && (
                  <InputGroup style={{ width: 400 }}>
                    <FormControl
                      placeholder="Nazwa"
                      value={producer}
                      onChange={(e) => setProducer(e.target.value)}
                    />
                    <Button
                      variant="outline-primary"
                      onClick={() =>
                        addItem(
                          values.mdfProducers,
                          'mdfProducers',
                          setFieldValue,
                        )
                      }
                    >
                      Dodaj
                    </Button>
                  </InputGroup>
                )}
                <FlexRow justify="flex-end">
                  <Button
                    variant="success"
                    type="submit"
                    disabled={!isEdit}
                  >
                    Zatwierdź
                  </Button>
                  <Button
                    variant={isEdit ? 'outline-secondary' : 'secondary'}
                    onClick={() => setIsEdit(!isEdit)}
                  >
                    {isEdit ? 'Zablokuj edycję' : 'Edytuj'}
                  </Button>
                </FlexRow>
              </Wrapper>
            </Form>
          );
        }}
      />
    </div>
  );
};

export default MdfProducers;
